<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="의견게시기간"
            name="period"
            :isToyear="true"
            v-model="searchParam.period"
          />
        </div>
      </template>
    </c-search-box>
    <div class="card-body qtable-card-body">
      <q-table
        grid
        class="qtable-card"
        title=""
        :data="grid.data"
        :columns="grid.columns"
        hide-header
        hide-bottom
        :rows-per-page-options="[0]"
        virtual-scroll
      >
        <template v-slot:top-right>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
            <q-card class="mobileTableCardLayer" @click="linkClick(props.row)">
              <q-card-section>
                <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.boardTitle }}</div>
              </q-card-section>
              <q-card-section class="grid-card-etc">
                <div class="text-grid-etc">
                  {{ props.row.regName }}
                </div>
              </q-card-section>
            </q-card>
          </div>
        </template>
      </q-table>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
        <q-card class="mobileTableCardLayer">
          <q-card-section class="text-center">
            <q-card-section class="q-pt-xs">
              <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
            </q-card-section>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safOpinionBoard',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'boardTitle',
            field: 'boardTitle',
            label: '제목',
            align: 'left',
            type: "link",
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'boardDate',
            field: 'boardDate',
            label: '의견게시일',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'regName',
            field: 'regName',
            label: '작성자/작성일',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        startYmd: '',
        endYmd: '',
        boardClassCd: 'BC00000001',
        period: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  beforeRouteLeave(to, from, next) { // history.back 일경우 팝업이라면 팝업을 닫자
    if (this.popupOptions.visible) {
      this.closePopup();
      next(false);
    } else {
      next();
    }
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.sai.sob.board.list.url;
      this.getList();
    },
    getList() {
      if (this.searchParam.period) {
        this.searchParam.startYmd = this.searchParam.period[0];
        this.searchParam.endYmd = this.searchParam.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.bookPopup(row);
    },
    bookPopup(result) {
      this.popupOptions.target = () => import(`${"./safOpinionBoardDetail.vue"}`);
      this.popupOptions.title = '안전 의견 게시판 상세';
      this.popupOptions.param = {
        boardId: result ? result.boardId : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
